<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow: auto; height: calc(100vh - 179px)">
            <es-org-tree
              @clickByOrg="queryFaultList"
              @completed="initOrgTree"
            ></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i
            >故障
          </div>
          <div class="es-op-box">
            <el-date-picker
              style="float: left; width: 280px"
              format="yyyy-MM-dd"
              v-model="dateTime"
              type="daterange"
              size="small"
              class="query"
              range-separator="至"
              start-placeholder="上报日期开始"
              end-placeholder="上报日期结束"
              clearable
              @clear="
                () => {
                  this.dateTime = [];
                }
              "
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              "
            >
            </el-date-picker>

            <el-select
              style="float: left"
              class="query"
              size="small"
              v-model="queryObj.systemId"
              placeholder="请选择系统专业"
              clearable
              filterable
              @clear="
                () => {
                  this.queryObj.pageNum = 1;
                  delete this.queryObj.systemId;
                  loadFaultList();
                }
              "
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              "
            >
              <el-option
                v-for="item in systems"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              style="float: left"
              class="query"
              size="small"
              v-model="queryObj.states"
              placeholder="请选择状态"
              clearable
              filterable
              @clear="
                () => {
                  delete this.queryObj.states;
                }
              "
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              "
            >
              <el-option
                v-for="item in statesArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-input
              placeholder="请输入故障单号"
              v-model="queryObj.keyWord"
              size="small"
              class="query"
              style="float: left"
              clearable
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              "
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <br /><br />
          <el-table
            :data="pageData.list"
            ref="faultTable"
            show-overflow-tooltip
            border
            stripe
            size="mini"
            height="calc(100vh - 250px)"
            v-loading="loading"
          >
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center"
            >
            </el-table-column>

            <el-table-column prop="code" label="故障单号"> </el-table-column>
            <el-table-column prop="systemName" label="系统专业">
            </el-table-column>
            <el-table-column prop="orgName" label="所属组织"> </el-table-column>
            <el-table-column prop="equiName" label="设备名称">
            </el-table-column>
            <el-table-column prop="occuTime" label="上报时间">
            </el-table-column>
            <el-table-column prop="duration" label="规定时长">
              <template slot-scope="scope">
                <span style="color: orange">{{ scope.row.duration }}小时</span>
              </template>
            </el-table-column>
            <el-table-column prop="planSolveTime" label="规定完成时间">
              <template slot-scope="scope">
                <span style="color: orange">{{ scope.row.planSolveTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="appeName"
              :show-overflow-tooltip="true"
              label="故障现象"
            >
            </el-table-column>
            <el-table-column
              prop="state"
              label="状态"
              width="110"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag size="mini" :type="stateFormat(scope.row, 1)">{{
                  scope.row.statename
                }}</el-tag>
                <el-tag
                  size="mini"
                  type="danger"
                  style="margin-left: 4px"
                  v-if="
                    scope.row.process != null &&
                    scope.row.process.startsWith('挂起')
                  "
                  >挂起</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" width="170" align="center">
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  title="分配"
                  v-if="scope.row.state == 3 || scope.row.isProf == 1"
                  disabled
                  @click="faultDist(scope.row)"
                  type="primary"
                  ><i class="el-icon-s-custom"></i
                ></el-link>
                <el-link
                  :underline="false"
                  title="分配"
                  v-else
                  @click="faultDist(scope.row)"
                  type="primary"
                  ><i class="el-icon-s-custom"></i
                ></el-link>

                <el-divider direction="vertical"></el-divider>
                <el-link
                  :underline="false"
                  title="提交专工"
                  v-if="scope.row.state == 3 || scope.row.isProf == 1"
                  disabled
                  @click="faultProf(scope.row)"
                  type="primary"
                  ><i class="el-icon-s-promotion"></i
                ></el-link>
                <el-link
                  :underline="false"
                  title="提交专工"
                  v-else
                  @click="faultProf(scope.row)"
                  type="primary"
                  ><i class="el-icon-s-promotion"></i
                ></el-link>

                <el-divider direction="vertical"></el-divider>
                <el-link
                  :underline="false"
                  title="激活"
                  v-if="scope.row.state != 3"
                  disabled
                  @click="faultActiv(scope.row)"
                  type="primary"
                  ><i class="el-icon-s-open"></i
                ></el-link>
                <el-link
                  :underline="false"
                  title="激活"
                  v-else
                  @click="faultActiv(scope.row)"
                  type="primary"
                  ><i class="el-icon-s-open"></i
                ></el-link>

                <el-divider direction="vertical"></el-divider>
                <el-link
                  :underline="false"
                  title="详情"
                  @click="view(scope.row)"
                  type="success"
                  ><i class="el-icon-font el-icon-view"></i
                ></el-link>

                <el-divider direction="vertical"></el-divider>
                <es-delete
                  @del="del(scope.row.id)"
                  v-if="scope.row.state == 3 || scope.row.isActived == 1"
                  disabled
                  type="icon"
                ></es-delete>
                <es-delete @del="del(scope.row.id)" v-else type="icon">
                </es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination
              :data="pageData"
              @change="
                (cpage) => {
                  this.queryObj.pageNum = cpage;
                  this.loadFaultList();
                }
              "
            >
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--故障分配-->
    <el-dialog
      :visible.sync="editVisible"
      @closed="
        () => {
          this.$refs['faultDistForm'].clearValidate();
        }
      "
      width="500px"
      style="padding-top: 0px"
    >
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>故障分配
      </span>
      <div v-loading="editLoading">
        <el-form
          :model="faultInfo"
          :inline="true"
          :rules="rules"
          size="mini"
          label-position="right"
          label-width="150px"
          ref="faultDistForm"
        >
          <el-form-item prop="resolverId" label="解决人">
            <el-select
              ref="resolverSelect"
              style="width: 200px"
              v-model="faultInfo.resolverId"
              placeholder="请选择解决人"
              clearable
              filterable
            >
              <el-option
                v-for="item in resolvers"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button size="mini" @click="editVisible = false">取 消</el-button>
        <el-button
          type="primary"
          size="mini"
          @click="submitFaultDist()"
          :loading="saving"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <!--故障提交专工-->
    <el-dialog
      :visible.sync="editVisibleProf"
      width="500px"
      style="padding-top: 0px"
    >
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>提交专工
      </span>
      <div v-loading="editLoading">
        <el-form
          :model="faultInfo"
          :inline="true"
          :rules="rules"
          size="mini"
          label-position="right"
          label-width="150px"
          ref="faultProfForm"
        >
          <el-form-item prop="des" label="说明">
            <el-input
              v-model="faultInfo.des"
              placeholder="提交专工说明"
              type="textarea"
              :rows="4"
              style="width: 200px"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button size="mini" @click="editVisibleProf = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="submitFaultProf()"
          :loading="saving"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <!--故障激活-->
    <el-dialog
      :visible.sync="editVisibleActiv"
      width="500px"
      style="padding-top: 0px"
    >
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>故障激活
      </span>
      <div v-loading="editLoading">
        <el-form
          :model="faultInfo"
          :inline="true"
          :rules="rules"
          size="mini"
          label-position="right"
          label-width="150px"
          ref="faultActivForm"
        >
          <el-form-item prop="des" label="说明">
            <el-input
              v-model="faultInfo.des"
              placeholder="故障激活说明"
              type="textarea"
              :rows="4"
              style="width: 200px"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button size="mini" @click="editVisibleActiv = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="submitFaultActiv()"
          :loading="saving"
          >保 存</el-button
        >
      </span>
    </el-dialog>

    <!--查看详情-->
    <el-dialog
      :visible.sync="viewVisible"
      width="1200px"
      style="padding-top: 0px"
    >
      <span slot="title">
        <i class="el-icon-font el-icon-view el-icon--left"></i>故障详情
      </span>

      <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="上报信息" name="first">
          <el-tabs type="card">
            <el-tab-pane label="基本信息">
              <div v-loading="viewLoading">
                <el-descriptions
                  :column="3"
                  style="cursor: pointer; margin-bottom: 12px"
                  size="mini"
                  border
                >
                  <el-descriptions-item
                    label="故障单号"
                    :labelStyle='labelStyle'
                    v-if="faultInfo.code != '' && faultInfo.code != null"
                    >{{ faultInfo.code }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="所属组织"
                    :labelStyle='labelStyle'
                    v-if="faultInfo.orgName != '' && faultInfo.orgName != null"
                    >{{ faultInfo.orgName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="所属区域"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.areaName != '' && faultInfo.areaName != null
                    "
                    >{{ faultInfo.areaName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="所属系统"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.systemName != '' && faultInfo.systemName != null
                    "
                    >{{ faultInfo.systemName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="设备类型"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.equiTypeName != '' &&
                      faultInfo.equiTypeName != null
                    "
                    >{{ faultInfo.equiTypeName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="设备型号"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.equiModelName != '' &&
                      faultInfo.equiModelName != null
                    "
                    >{{ faultInfo.equiModelName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="设备名称"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.equiName != '' && faultInfo.equiName != null
                    "
                    >{{ faultInfo.equiName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="设备模块"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.equiModuleName != '' &&
                      faultInfo.equiModuleName != null
                    "
                    >{{ faultInfo.equiModuleName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="上报时间"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.occuTime != '' && faultInfo.occuTime != null
                    "
                    >{{ faultInfo.occuTime }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="上报人"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.reporteName != '' &&
                      faultInfo.reporteName != null
                    "
                    >{{ faultInfo.reporteName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="解决人"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.resolverName != '' &&
                      faultInfo.resolverName != null
                    "
                    >{{ faultInfo.resolverName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="协作人"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.companionName != '' &&
                      faultInfo.companionName != null
                    "
                    >{{ faultInfo.companionName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="规定解决时长"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.duration != '' && faultInfo.duration != null
                    "
                    >{{ faultInfo.duration }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="规定解决时间"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.planSolveTime != '' &&
                      faultInfo.planSolveTime != null
                    "
                    >{{ faultInfo.planSolveTime }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="故障等级"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.levelName != '' && faultInfo.levelName != null
                    "
                    >{{ faultInfo.levelName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="故障现象"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.appeName != '' && faultInfo.appeName != null
                    "
                    >{{ faultInfo.appeName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="故障描述"
                    :labelStyle='labelStyle'
                    v-if="faultInfo.des != '' && faultInfo.des != null"
                    >{{ faultInfo.des }}</el-descriptions-item
                  >
                  <el-descriptions-item label="当前状态" :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ stateFormat(faultInfo, 2) }}</el-tag>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item label="是否专工" :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ isProfFormat(faultInfo) }}</el-tag>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item label="是否曾经激活" :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ isActivedFormat(faultInfo) }}</el-tag>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item label="来源" :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ sourceFormat(faultInfo) }}</el-tag>
                    </div></el-descriptions-item
                  >
                </el-descriptions>

                <es-img
                  :info="faultInfo"
                  :fileList="fileListView"
                  type="view"
                ></es-img>

                <!-- 扩展属性 -->
                <es-extend :extendData="extendData" type="view"></es-extend>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>

        <el-tab-pane label="解决信息" name="second">
          <el-tabs type="card">
            <el-tab-pane label="基本信息">
              <div v-loading="viewLoading">
              <el-descriptions
                :column="3"
                style="cursor: pointer; margin-bottom: 12px"
                size="mini"
                border
              >
                <el-descriptions-item
                  label="到场时间"
                  :labelStyle='labelStyle'
                  v-if="
                    faultInfo.arriveTime != '' && faultInfo.arriveTime != null
                  "
                  >{{ faultInfo.arriveTime }}</el-descriptions-item
                >
                <el-descriptions-item
                  label="解决时间"
                  :labelStyle='labelStyle'
                  v-if="
                    faultInfo.solveTime != '' && faultInfo.solveTime != null
                  "
                  >{{ faultInfo.solveTime }}</el-descriptions-item
                >
                <el-descriptions-item
                  label="解决人"
                  :labelStyle='labelStyle'
                  v-if="
                    faultInfo.resolverName != '' &&
                    faultInfo.resolverName != null
                  "
                  >{{ faultInfo.resolverName }}</el-descriptions-item
                >
                <el-descriptions-item
                  label="解决方法"
                  :labelStyle='labelStyle'
                  v-if="
                    faultInfo.solutionName != '' &&
                    faultInfo.solutionName != null
                  "
                  >{{ faultInfo.solutionName }}</el-descriptions-item
                >
                <el-descriptions-item
                  label="解决方法描述"
                  :labelStyle='labelStyle'
                  v-if="
                    faultInfo.solutionDes != '' && faultInfo.solutionDes != null
                  "
                  >{{ faultInfo.solutionDes }}</el-descriptions-item
                >
                <el-descriptions-item
                  label="解决措施"
                  :labelStyle='labelStyle'
                  v-if="faultInfo.measures != '' && faultInfo.measures != null"
                  >{{ faultInfo.measures }}</el-descriptions-item
                >
                <el-descriptions-item label="当前状态" :labelStyle='labelStyle'>
                  <div style="width: 200px">
                    <el-tag>{{ stateFormat(faultInfo, 2) }}</el-tag>
                  </div>
                </el-descriptions-item>
              </el-descriptions>
              <!-- 扩展属性 -->
              <es-extend :extendData="extendDataSolve" type="view"></es-extend>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>

        <el-tab-pane label="材料消耗" name="third">
          <el-table
            :data="matConsume"
            ref="matConsumeTable"
            show-overflow-tooltip
            border
            stripe
            size="mini"
            height="calc(70vh - 250px)"
            v-loading="loading"
          >
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="matTypeName" label="材料类型">
            </el-table-column>
            <el-table-column prop="matModelName" label="材料型号">
            </el-table-column>
            <el-table-column prop="unit" label="单位"> </el-table-column>
            <el-table-column prop="quantity" label="数量"> </el-table-column>
            <el-table-column prop="matNumber" label="材料序列号">
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="处理过程" name="fourth">
          <el-row :gutter="20">
            <el-col :span="6">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="16">
              <div class="block" v-loading="viewLoading">
                <el-timeline>
                  <el-timeline-item
                    v-for="(activity, index) in activities"
                    :key="index"
                    :icon="activity.icon"
                    :type="activity.type"
                    :color="activity.color"
                    :size="activity.size"
                    :timestamp="activity.timestamp"
                  >
                    {{ activity.content }}
                  </el-timeline-item>
                </el-timeline>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import esExtend from "../common/es-extend.vue";
import dateutils from "../../utils/dateutils.js";

export default {
  components: { esExtend },
  name: "faultdist",
  props: ["funcs"],
  data() {
    return {
      //label样式
      labelStyle: { 'width': '120px' },
      orgTree: [], //所属组织
      areas: [], //区域
      statesArr: [
        { id: 1, name: "待分配" },
        { id: 2, name: "待解决" },
        { id: 3, name: "已解决" },
      ], //状态
      systems: [], //系统专业
      dateTime: [], //上报起止日期
      resolvers: [], //解决人
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      editVisible: false,
      editVisibleProf: false,
      editVisibleActiv: false,

      faultInfo: {}, //故障信息
      fauProcess: {}, //故障处理过程信息
      activeName: "first",
      extendDataReport: [], //上报信息的扩展信息
      extendDataSolve: [], //解決信息的扩展信息
      viewVisible: false,
      loading: false,
      editLoading: false,
      viewLoading: false,
      saving: false,
      url: "",
      fileList: [],
      fileListView: [],
      repairInfo: {},
      activeRepairName: "first",
      viewRepairLoading: false,
      viewRepairVisible: false,
      fileRepairListView: [],
      fileRepairHandleList: [],
      activities: [], //处理过程
      matConsume: [], //材料消耗

      resolverIdArr: [], //协作人
      appes: [],
      levels: [],
      rules: {
        //验证条件
        resolverId: [
          { required: true, message: "请选择解决人", trigger: "blur" },
        ],
        appeId: [
          { required: true, message: "请选择故障现象", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //页面初始化
    init() {
      this.loadSystemListAll();
      this.loadFaultList();
    },

    initOrgTree(orgTree) {
      this.orgTree = orgTree;
    },

    //初始化系统下拉框
    loadSystemListAll() {
      this.$ajax
        .get("/base/system/list_all")
        .then((msg) => {
          this.systems = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    //初始化故障现象下拉框
    loadFauAppeListAll(typeId) {
      this.$ajax
        .get("/base/fauAppe/list_all", {
          typeId: typeId,
        })
        .then((msg) => {
          this.appes = msg;
          this.appes.push({
            id: 999999,
            name: "自定义",
          });
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //从后台查询故障列表
    loadFaultList() {
      this.loading = true;

      this.$set(this.queryObj, "occuTimeStart", null);
      this.$set(this.queryObj, "occuTimeEnd", null);
      //上报起止日期格式化
      if (this.dateTime != null && this.dateTime.length != 0) {
        this.$set(
          this.queryObj,
          "occuTimeStart",
          dateutils.dateFormat("YYYY-mm-dd", this.dateTime[0]) + " 00:00:00"
        );
        this.$set(
          this.queryObj,
          "occuTimeEnd",
          dateutils.dateFormat("YYYY-mm-dd", this.dateTime[1]) + " 23:59:59"
        );
      }

      this.$set(this.queryObj, "orderBy", "state asc,create_time desc");
      this.$ajax
        .get("/buss/fault/list", this.queryObj)
        .then((msg) => {
          this.pageData = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },

    queryFaultList(orgIds) {
      this.queryObj.pageNum = 1;
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(",");
      }
      this.loadFaultList();
    },

    //保存故障分配信息
    submitFaultDist() {
      this.faultInfo.receive = 1;
      this.faultInfo.resolverName = this.$refs.resolverSelect.selected.label;
      // var resolverNameArr = this.$refs.resolverSelect.selected.map(
      //   (v) => v.label
      // ); //获取解决人名称数组
      // if (this.resolverIdArr.length > 0) {
      //   this.faultInfo.resolverName = resolverNameArr.join(",");
      //   this.faultInfo.resolverId = this.resolverIdArr.join(",");
      // }
      this.$refs["faultDistForm"].validate((valid) => {
        if (valid) {
          let url = "/buss/fault/edit_fault_dist";
          this.saving = true;
          this.$ajax
            .post(url, this.faultInfo)
            .then((msg) => {
              this.saving = false;
              this.loadFaultList();
              this.editVisible = false;
              this.$message.success(msg);
            })
            .catch((err) => {
              this.$message.error(err);
              this.saving = false;
            });
        }
      });
    },
    //保存提交专工信息
    submitFaultProf() {
      let url = "/buss/fault/edit_fault_prof";
      this.saving = true;
      this.$ajax
        .post(url, this.faultInfo)
        .then((msg) => {
          this.saving = false;
          this.loadFaultList();
          this.editVisibleProf = false;
          this.$message.success(msg);
        })
        .catch((err) => {
          this.$message.error(err);
          this.saving = false;
        });
    },
    //保存激活信息
    submitFaultActiv() {
      let url = "/buss/fault/edit_fault_activ";
      this.saving = true;
      this.$ajax
        .post(url, this.faultInfo)
        .then((msg) => {
          this.saving = false;
          this.loadFaultList();
          this.editVisibleActiv = false;
          this.$message.success(msg);
        })
        .catch((err) => {
          this.$message.error(err);
          this.saving = false;
        });
    },
    //删除故障信息
    del(delId) {
      let ids = [];
      if (delId != null) {
        ids = [delId];
      } else {
        this.$refs["faultTable"].selection.forEach((ele) => {
          ids.push(ele.id);
        });
      }
      if (ids.length > 0) {
        this.loading = true;
        this.$ajax
          .post("/buss/fault/delete", { ids: ids })
          .then((msg) => {
            this.loading = false;
            this.$message.success(msg);
            this.queryObj.pageNum = 1; //删除之后，回到第一页
            this.loadFaultList();
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    faultDist(row) {
      this.resolvers = [];
      this.editVisible = true;
      this.faultInfo = JSON.parse(JSON.stringify(row));
      if (
        this.faultInfo.resolverId != null &&
        this.faultInfo.resolverId != ""
      ) {
        this.faultInfo.resolverId = Number.parseInt(this.faultInfo.resolverId);
      }
      this.$ajax
        .get("/base/account/list_charge_person", {
          systemId: row.systemId,
          orgId: row.orgId,
        })
        .then((msg) => {
          this.resolvers = msg;
          console.log(this.resolvers);
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    faultProf(row) {
      this.editVisibleProf = true;
      this.faultInfo = {};
      this.faultInfo.id = row.id;
    },

    faultActiv(row) {
      this.editVisibleActiv = true;
      this.faultInfo = {};
      this.faultInfo.id = row.id;
    },
    //查看故障详情
    view(row) {
      this.viewVisible = true;
      this.viewLoading = true;
      this.fileListView = [];
      this.activeName = "first";
      this.$ajax
        .get("/buss/fault/load_detail", { id: row.id })
        .then((msg) => {
          //初始化图片
          if (msg.attachImgs != null && msg.attachImgs != "") {
            let temp = JSON.parse(msg.attachImgs);
            temp.forEach((e) => {
              this.fileListView.push(
                this.$api +
                  e.url +
                  "&platform=web&token=" +
                  this.$store.getUser().token
              );
            });
          }

          this.faultInfo = msg;

          //加载解決扩展属性
          this.$ajax
            .get("/buss/fault/extend_data", {
              fauId: this.faultInfo.id,
              typeId: 1,
            })
            .then((msg) => {
              this.extendDataReport = msg;
            })
            .catch((err) => {
              this.$message.error(err);
            });

          //加载解決扩展属性
          this.$ajax
            .get("/buss/fault/extend_data", {
              fauId: this.faultInfo.id,
              typeId: 2,
            })
            .then((msg) => {
              this.extendDataSolve = msg;
            })
            .catch((err) => {
              this.$message.error(err);
            })
            .finally(() => {
              this.viewLoading = false;
            });
        })
        .catch((err) => {
          this.$message.error(err);
          this.viewVisible = false;
          this.viewLoading = false;
        });
    },
    viewRepair(row) {
      this.viewRepairVisible = true;
      this.viewRepairLoading = true;
      this.fileRepairListView = [];
      this.fileRepairHandleList = [];
      this.repairInfo = {};
      this.activeName = "first";
      this.$ajax
        .get("/buss/repair/load_detail", { id: row.id })
        .then((msg) => {
          //初始化图片
          if (msg.attachImgs != null && msg.attachImgs != "") {
            let temp = JSON.parse(msg.attachImgs);
            temp.forEach((e) => {
              this.fileRepairListView.push(
                this.$api +
                  e.url +
                  "&platform=web&token=" +
                  this.$store.getUser().token
              );
            });
          }
          //初始化图片
          if (msg.handleImgs != null && msg.handleImgs != "") {
            let temp = JSON.parse(msg.handleImgs);
            temp.forEach((e) => {
              this.fileRepairHandleList.push(
                this.$api +
                  e.url +
                  "&platform=web&token=" +
                  this.$store.getUser().token
              );
            });
          }
          console.log(msg);
          this.viewRepairLoading = false;
          this.repairInfo = msg;
        })
        .catch((err) => {
          this.$message.error(err);
          this.viewRepairVisible = false;
          this.viewRepairLoading = false;
        });
    },

    isProfFormat(row) {
      if (row.isProf == 0) {
        return "否";
      } else {
        return "是";
      }
    },
    isActivedFormat(row) {
      if (row.isActived == 0) {
        return "否";
      } else {
        return "是";
      }
    },
    sourceFormat(row) {
      if (row.source == 1) {
        return "手机端";
      } else {
        return "WEB端";
      }
    },

    //显示状态，type=1列表用，type=2详情用
    stateFormat(row, type) {
      if (row.state == 1) {
        if (type == 1) {
          row.statename = "待分配";
          return "warning";
        }
        return "待分配";
      } else if (row.state == 2) {
        if (type == 1) {
          row.statename = "待解决";
          return "primary";
        }
        return "待解决";
      } else {
        if (type == 1) {
          row.statename = "已解决";
          return "success";
        }
        return "已解决";
      }
    },

    handleTabClick(tab) {
      if (tab.name == "fourth") {
        this.viewLoading = true;
        this.activities = [];
        this.$ajax
          .get("/buss/fault/list_fau_process", { fauId: this.faultInfo.id })
          .then((msg) => {
            msg.forEach((ele) => {
              this.fauProcess = {};
              this.fauProcess.content =
                (ele.senderName == null ? "" : ele.senderName) +
                "【" +
                (ele.des == null ? "" : ele.des) +
                "】" +
                (ele.receiverName == null ? "" : ele.receiverName);
              this.fauProcess.timestamp = ele.createTime;
              this.fauProcess.color = "#0bbd87";
              this.fauProcess.icon = "el-icon-star-on";
              this.activities.push(this.fauProcess);
            });
          })
          .finally(() => {
            this.viewLoading = false;
          })
          .catch((err) => {
            this.$message.error(err);
            this.viewLoading = false;
          });
      }

      if (tab.name == "third") {
        this.viewLoading = true;
        this.matConsume = [];
        this.$ajax
          .get("/buss/fault/list_mat_consume", { fauId: this.faultInfo.id })
          .then((msg) => {
            this.matConsume = msg;
          })
          .finally(() => {
            this.viewLoading = false;
          })
          .catch((err) => {
            this.$message.error(err);
            this.viewLoading = false;
          });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style></style>
